module.exports = __webpack_public_path__ + "static/media/jake-whitesell-home-reduced-more.7112cc8c.jpg";